import axios from 'axios';
import {
  MEMBER_LIST_URL,
  CREATE_CHAT_ROOM_URL,
  CREATE_CHAT_GROUP_ROOM_URL,
  LEAVE_CHAT_GROUP_ROOM_URL,
  UPDATE_SOCIAL_GROUP_PARTICIPANTS_URL,
  UPDATE_CHAT_GROUP_ROOM_URL,
} from '../constants/endpoints';
import wix from './wix';
import { SiteMember } from '../components/ChatCreation/ChatCreation';

export const defaultUserName = '_';

export interface GetMembersResponse {
  members: SiteMember[];
  nextPage?: number;
}

export interface NewPrivateChatroomResponse {
  chatroomId: string;
  chatroom: {
    displayData: {
      name: string;
      image?: {
        url?: string;
      };
    };
  };
}

class SocialServerApi {
  instance;

  constructor() {
    this.instance = wix.getInstance();
  }

  _fetch(options) {
    options.headers = {
      ...options.headers,
      Authorization: this.instance,
    };
    return axios(options).then((response) => response.data);
  }

  getMembers(
    from: number = 0,
    searchTerm?: string,
  ): Promise<GetMembersResponse> {
    return this._fetch({
      method: 'get',
      url: MEMBER_LIST_URL,
      params: {
        filter: searchTerm,
        pageSize: 50,
        from,
      },
      paramsSerializer: customSerializer,
    });
  }

  createPrivateChatRoom(userId): Promise<NewPrivateChatroomResponse> {
    return this._fetch({
      method: 'post',
      url: CREATE_CHAT_ROOM_URL,
      data: {
        otherParticipant: {
          userId,
        },
      },
    });
  }

  createGroupChatRoom(
    participants: {}[],
    groupChatroomName: string,
    groupChatroomImage: any = null,
  ): Promise<NewPrivateChatroomResponse> {
    return this._fetch({
      method: 'post',
      url: CREATE_CHAT_GROUP_ROOM_URL,
      data: {
        participants,
        name: groupChatroomName,
        image: groupChatroomImage,
      },
    });
  }

  leaveGroupChatRoom(chatroomId: string): any {
    return this._fetch({
      method: 'put',
      url: LEAVE_CHAT_GROUP_ROOM_URL,
      data: {
        chatroomId,
      },
    });
  }

  removeParticipantFromChatRoom(chatroomId: string, participantId: string) {
    return this._fetch({
      method: 'post',
      url: UPDATE_SOCIAL_GROUP_PARTICIPANTS_URL,
      data: {
        chatroomId,
        joinChatroomCandidateIds: [],
        leaveChatroomCandidateIds: [participantId],
      },
    });
  }

  addMembersToChatRoom(chatroomId: string, memberIds: string[]) {
    return this._fetch({
      method: 'post',
      url: UPDATE_SOCIAL_GROUP_PARTICIPANTS_URL,
      data: {
        chatroomId,
        joinChatroomCandidateIds: memberIds,
        leaveChatroomCandidateIds: [],
      },
    });
  }

  updateGroupChatRoom(
    chatroomId: string,
    name: string,
    image: any = null,
  ): any {
    return this._fetch({
      method: 'put',
      url: `${UPDATE_CHAT_GROUP_ROOM_URL}/${chatroomId}`,
      data: {
        chatroomId,
        name,
        image,
      },
    });
  }
}

export default new SocialServerApi();

function customSerializer(params: any): string {
  return Object.keys(params)
    .map((key: any) => {
      const val: any = params[key];
      if (val === null || typeof val === 'undefined') {
        return;
      }
      return encodeURIComponent(key) + '=' + encodeURIComponent(val);
    })
    .join('&');
}
